document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-patouno-swatch]');
  if (!swatch) return;

  const card = swatch.closest('[data-patouno-favoris-card]');
  if (!card) return;

  card.querySelectorAll('[data-patouno-swatch]').forEach((el) => el.classList.remove('is-active'));
  swatch.classList.add('is-active');

  const image = card.querySelector('[data-patouno-favoris-image]');
  if (image && swatch.dataset.image) {
    image.src = swatch.dataset.image;
  }

  const price = card.querySelector('[data-patouno-favoris-price]');
  if (price && swatch.dataset.price) {
    price.textContent = swatch.dataset.price;
  }
});
